











































































import { Component, Vue } from 'vue-property-decorator';

import LoadingDataCard from '@/vue-app/components/home-dashboard/LoadingDataCard.vue';
import FlagshipTrackingGoalsCardViewModel
  from '@/vue-app/view-models/components/my-investment-dashboard-v2/flagship-tracking-goals-card-view-model';

@Component({
  name: 'FlagshipTrackingGoalsCard',
  components: {
    LoadingDataCard,
    CustomTooltip: () => import('@/vue-app/components/custom/CustomTooltip.vue'),
  },
})
export default class FlagshipTrackingGoalsCard extends Vue {
  view_model = Vue.observable(new FlagshipTrackingGoalsCardViewModel());

  created() {
    this.view_model.initialize();
  }
}
